module.exports = __webpack_public_path__ + "static/media/homeBG.286a9900.png";